import { TextField } from '@client/new/components/basic';

type SearchBoxProps = {
  onChange: (value: string) => void;
  value: string;
};
export function SearchBox({ onChange, value }: SearchBoxProps) {
  return (
    <div className="flex gap-4 w-full">
      <div>
        <TextField
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search by name or email"
          sx={{ width: '200px !important' }}
        />
      </div>
    </div>
  );
}
